module.exports = __webpack_public_path__ + "media/src/assets/images/analytics-5615f317c2c8943dad2c96452bfdb391.svg";